import React, { useState } from "react";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Devices } from '@mui/icons-material/';

const style = { //Estilos para el contenedor del mensaje.
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1100,
    bgcolor: '#161B22',
    border: '2px solid #161B22',
    color: '#ffffff',
    boxShadow: 24,
    p: 5,
    display: "flex",
    zIndex: 300000
};

const textBoldStyle = { //Estilo para los textos en negritas
    fontWeight: 'bold',
    width: "100%",
    marginRight: "5px"
}

// ModalActiveSessionsList: Componente que renderiza la lista de sesiones activas en otros dispositivos.

const ModalActiveSessionsList = ({ openModal, setOpenModal, sessionActiveData, onHandleReconnectionSession }) => {
    const handleClose = () => setOpenModal(false);

    return (
        <Modal open={openModal} onClose={handleClose} aria-labelledby="modal-modal-title" sx={{ zIndex: 100000 }}
            aria-describedby="modal-modal-description">
            <Box sx={style}>
                <div className="container-title-with-description">
                    <Typography id="modal-modal-description" variant="h5" sx={{ width: "100%" }}
                        fontFamily="Poppins" fontWeight="600">
                        Sesiones del navegador
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 3  }} fontFamily="Poppins" >
                        Administre y cierre sesión en sus <strong>sesiones activas </strong> en
                        otros navegadores o dispositivos.
                    </Typography>
                </div>
                <div className="container-instruccion-with-data" >
                    <Typography id="modal-modal-description" fontFamily="Poppins"
                        justifyContent="center" display="flex" sx={{ flexDirection: "column" }}>
                         Al iniciar sesión en este navegador, se cerrará la sesión existente en el navegador:
                    </Typography>
                    <div className="container-intruccion-with-data__data">
                        <span><Devices sx={{ marginRight: "20px", fontSize: "30px" }} /></span>
                        <div className="container-browser-with-data" >
                            <Typography component="span" variant="inherit" sx={textBoldStyle} className="title-browser">
                                {sessionActiveData.Navegador}
                            </Typography>
                            <div className="hour-with-ip">
                                <Typography component="span" variant="inherit">
                                    {sessionActiveData.Ip} - 
                                </Typography>
                                <Typography component="span" variant="inherit">
                                     {sessionActiveData.So}
                                </Typography>
                            </div>
                        </div>
                    </div>
{/*                     <Typography id="modal-modal-description" sx={{ mt: 2 }} fontFamily="Poppins" justifyContent="center" display="flex">
                        <button className="btn-submit-info" onClick={handleClose}>Cerrar sesión en otras sesiones del navegador</button>
                    </Typography> */}
                    <Typography id="modal-modal-description" sx={{ mt: 2 }} fontFamily="Poppins" justifyContent="center" display="flex">
                        <button className="btn-submit-info" onClick={() => onHandleReconnectionSession()}>Iniciar Sesión en este navegador</button>
                    </Typography>
                </div>
            </Box>
        </Modal>

    )
};

export default ModalActiveSessionsList;